import { Radio } from 'lucide-react'
import { useSearchParams } from 'react-router-dom'

import { useAgentListening } from '@/context/agent-listening-context'
import { isSupportChipVisible } from '@/lib/agent-listening-chrome'
import { cn } from '@/lib/utils'

/**
 * Mode chip for the agent column while a discourse session is bound to this thread.
 * Hidden when the operator has switched to another thread.
 */
export function AgentSupportModeChip({ className }: { className?: string }) {
  const { active, sessionId, label, modeLabel, supportThreadId, ended } = useAgentListening()
  const [searchParams] = useSearchParams()
  const openThreadId = searchParams.get('thread')

  if (
    !isSupportChipVisible({
      active,
      sessionId,
      supportThreadId,
      openThreadId,
    })
  ) {
    return null
  }

  return (
    <div
      className={cn(
        'flex items-center gap-2 border-b border-border bg-muted/30 px-3 py-2',
        className,
      )}
      aria-label={ended ? 'Session support mode ended' : 'Live session support mode'}
    >
      <Radio className="size-3.5 shrink-0 text-primary" aria-hidden />
      <p className="text-xs font-medium">{modeLabel || 'Live support'}</p>
      {label ? (
        <p className="min-w-0 truncate text-xs text-muted-foreground">· {label}</p>
      ) : null}
      {ended ? (
        <span className="ms-auto text-xs text-muted-foreground" role="status">
          Ended
        </span>
      ) : (
        <span
          className="ms-auto size-2 shrink-0 rounded-full bg-success"
          role="status"
          aria-label="Live"
        />
      )}
    </div>
  )
}
